import {callURL} from './call';
import messageShow from "./messageShow";
import {signerURL} from "../url";
import logout from "./logout";
import {UPDATE_DATA, GET_CUSTOMIZATION} from "../types";

const isLoggedIn= (formValues) => async (dispatch) =>
{
    const onResult= (result) =>
    {
        if(result && result[1] && result[1].success)
        {
            if(result[1].loggedIn)
                dispatch({type:UPDATE_DATA,payload: {advisor:true}});
            else
                dispatch(logout());
        }
        else
        {
            dispatch(messageShow({message: result[1].error, type: 'error'}));
            dispatch(logout());
        }
    }

    const onResultCustomization = (result) =>{
        if(result && result[1] && result[1].success)
        {
            if(result[1].customization){
                const customization = result[1].customization.replace(/"/g, "").replace(/\\/g, "\"")
                const data = {
                    customization: customization?JSON.parse(customization):''
                }
                dispatch({ type: GET_CUSTOMIZATION, payload: data });
            }
        }
        else
        {
            dispatch(messageShow({message: result[1].error, type: 'error'}));
        }
    }
    dispatch(callURL(signerURL,"rest/LoginService/isLoggedIn",formValues,formValues && formValues.customization?onResultCustomization:onResult));
};
export default isLoggedIn;